import React from 'react';
import {
    Page,
    TextField,
    Layout,
    Card,
    Select,
    FormLayout,
    Stack,
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../../common/Helpers';
import { GenieTag } from "../../../components/GenieTag";
import { Helmet } from 'react-helmet';

class SmartCollectionProductTagsValidationRuleComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            name: "",
            currentTag: null,
            requiredTags: [],
            smartCollectionId: null,
            smartCollections: []
        };

        if (props.rule != null) {
            this.state.name = props.rule.name;
            this.state.requiredTags = props.rule.requiredTags;
            this.state.smartCollectionId = props.rule.smartCollectionId;
        };

        this.previewTimer = null;
    }

    render() {

        var hasName = this.state.name != null && this.state.name !== "";
        var canSave = hasName;
        var tags = this.state.requiredTags.map(_ => <GenieTag id={_} onClick={this.onTagClick}>{_}</GenieTag>)
        var smarCollectionOptions = this.state.smartCollections.map(_ => {
            return {
                label: _.title,
                value: _.id
            }
        });

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Validation Rules - Validate Product Tags In A Smart Collection</title>
                </Helmet>
                <Page
                    title={this.props.title}
                    primaryAction={{ content: this.props.actionTitle, onAction: this.handleSave, disabled: !canSave }}
                    breadcrumbs={[{ content: 'Tag Rules', url: '/validation-rules' }]}
                >
                    <Layout fullWidth>
                        <Layout.Section oneHalf>
                            <Card>
                                <Card.Section>
                                    <p>Validate Product Tags In A Smart Collection.</p>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <TextField
                                            label="Rule Name"
                                            placeholder="Rule name"
                                            helpText={
                                                <span>
                                                    Give a name to easily identify this custom product rule.
                                                </span>
                                            }
                                            value={this.state.name}
                                            error={hasName ? null : "Must have name"}
                                            onChange={this.handleNameChange}
                                            autoComplete="off"
                                        />
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <Select
                                            label="Smart collection to validate"
                                            options={smarCollectionOptions}
                                            onChange={this.onSmartCollectionChange}
                                            value={this.state.smartCollectionId}
                                            helpText={
                                                <span>
                                                    Any products belonging to the selected smart collection will be tested to require the required tags.
                                                </span>
                                            }
                                        />
                                        <TextField
                                            label="Required tags"
                                            value={this.state.currentTag}
                                            name="tagInputField"
                                            placeholder="Enter tag name and press enter. Click on tags to remove."
                                            onChange={this.onCurrentTagChange}
                                            helpText={
                                                <span>
                                                    List of tags that are expected to be applied to all products in the selected smart collection.
                                                </span>
                                            }
                                        />
                                    </FormLayout>
                                    <br />
                                    <Stack>
                                        {tags}
                                    </Stack>
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                        <Layout.Section oneThird>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div >
        );
    }

    handleSelectTags = () => {
        this.setState({
            modalActive: true
        });
    }

    handleNameChange = (value) => {
        this.setState({ name: value });
    }

    onSmartCollectionChange = (value) => {
        this.setState({ smartCollectionId: value });
    }

    onCurrentTagChange = (newValue) => {
        this.setState({
            currentTag: newValue
        });
    }

    onTagClick = (tagName) => {

        var selectedIndex = this.state.requiredTags.findIndex(_ => _ === tagName);
        var newTags = [
            ...this.state.requiredTags.slice(0, selectedIndex),
            ...this.state.requiredTags.slice(selectedIndex + 1)
        ];

        this.setState({
            requiredTags: newTags
        });
    }

    handleSave = () => {

        this.props.onAction({
            name: this.state.name,
            requiredTags: this.state.requiredTags,
            smartCollectionId: this.state.smartCollectionId,
        })
    }

    onKeyDown = (event) => {

        if (event.code === 'Enter' && event.target != null && event.target.name === "tagInputField") {

            if (this.state.currentTag != null) {
                this.setState({
                    currentTag: null,
                    requiredTags: [...this.state.requiredTags, this.state.currentTag]
                }, null)
            }
        }
    }

    componentDidMount() {
        window.document.addEventListener('keydown', this.onKeyDown, {
            capture: false,
            once: false,
            useCapture: false,
            passive: true,
        });

        fetch(`api/products/smartCollections`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                smartCollections: data
            }));
    }
}

export default SmartCollectionProductTagsValidationRuleComponent;